import {Column} from 'devextreme-react/data-grid';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {GroupItem, SimpleItem, Label} from "devextreme-react/form";
import IMetierSecteur from "../../models/IMetierSecteur";
import {FormListBase, FormListBaseTab, FormListBaseGrid} from '../base';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

export default function SecteursMetier() {
    const metierSecteurFormDataSource = useCustomDataSource<IMetierSecteur, IMetierSecteur>({path: "metierSecteur", primaryKey: "idMetierSecteur"});
    const {selectedDataRow: selectedMetierSecteur, mode, setMode, isFieldModifier, setIsFieldModifier} = metierSecteurFormDataSource;
    return (
        <FormListBase data={metierSecteurFormDataSource}>
            <FormListBaseGrid dataSource={metierSecteurFormDataSource.dataSource}>
                <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false}/>
            </FormListBaseGrid>
            <FormListBaseTab>
                <TabItem title="Informations">
                    <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedMetierSecteur || {} as IMetierSecteur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                        <GroupItem>
                            <SimpleItem key={"frm-description"} dataField={"description"}>
                                <Label text={"Description"}/>
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                </TabItem>
                <TabItem title="Système"><FormSysteme formData={selectedMetierSecteur || {} as IMetierSecteur}/></TabItem>
            </FormListBaseTab>
        </FormListBase>
    );
}
